module.exports = __webpack_public_path__ + "img/banner1.3c1fa11a.png";